
export enum TypePeriodeFacturationEnum {
  EN_COURS= 'EN_COURS',
  PASSE = 'PASSE',
  FUTUR = 'FUTUR'
}
